import { Icon } from '@nazka/nazka.mapframe.components';
import { Pie, PieChart } from 'recharts';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import PopupTitle from '@App/components/MaplibreMap/PopupTitle';
import { useTranslation } from '@utils/i18n/i18n';

import { getChartData } from './observations-popup.utils';

import './observations-popup.css';

function ObservationsPopup({ feature }) {
  const { chartData, total } = getChartData(feature);

  const { t } = useTranslation();

  return (
    <div className="observations-popup">
      <PopupTitle>{feature?.properties?.name}</PopupTitle>
      <div className="observations-popup__content">
        <div className="observations-popup__chart">
          {chartData.length > 0 && (
            <PieChart width={160} height={160}>
              <Pie
                isAnimationActive={true}
                data={chartData}
                dataKey="value"
                nameKey="label"
                cx="50%"
                cy="50%"
                innerRadius="80%"
                outerRadius="100%"
                cornerRadius="50%"
                paddingAngle={5}
                stroke="none"
              />
            </PieChart>
          )}
        </div>
        <div className="observations-popup__legend">
          {chartData.length > 0
            ? chartData.map(({ key, label, color, icon, value }) => (
                <div key={key} className="observations-popup__legend-item">
                  <Icon
                    className="observations-popup__legend-icon"
                    css={{ backgroundColor: color }}
                    color="white"
                    icon={icon}
                    size="36px"
                  />
                  <div className="observations-popup__legend-text">
                    <span>{label}</span>
                    <span>
                      <strong>
                        {total > 0 ? (value / total * 100).toFixed(2) : 0}
                        %
                      </strong>
                      <span>
                        {` (${value})`}
                      </span>
                    </span>
                  </div>
                </div>
              ))
            : (
                <p className="observations-popup__empty">{t('No observations data available.')}</p>
              )}
        </div>
      </div>
      <a className="observations-popup__link" href={feature.properties.observationCounts?.url} target="_blank" rel="noopener noreferrer">
        {t('Explore observations in MINKA')}
        <Icon className="observations-popup__link__icon" icon={faArrowRight} size="32px" css={{ marginLeft: '4px' }} />
      </a>
    </div>
  );
}

export default ObservationsPopup;
